import { CONFIG_BASE_URL } from './consts'
import axios from 'axios'

import dispatch from '../utils/dispatchStore';
import { store } from '../store/index.js';
import actions from '../store/actions'

let axiosConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
};

if (process.env.NODE_ENV === 'production') {
  axiosConfig = {
    ...axiosConfig,
    baseURL: CONFIG_BASE_URL,
  };
}

export const requestConfig = axios.create(axiosConfig);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

requestConfig.interceptors.request.use(
  async response => {
    const token = store.getState().tokenInfo.access;

    if (token) {
      response.headers.common['Authorization'] = `JWT ${token}`;
    }

    return response;
  },
  error => Promise.reject(error)
);

requestConfig.interceptors.response.use(
  response => response,
  error => {
    const _axios = axios;
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry
    ) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers['Authorization'] = `JWT ${token}`;
            originalRequest.data = originalRequest.data
              ? JSON.parse(originalRequest.data)
              : originalRequest.data;
            return _axios.request(originalRequest);
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = store.getState().tokenInfo.refresh;
      return new Promise(function (resolve, reject) {
        axios
          .post('api/v1/auth/token-refresh/', { token: refreshToken }, axiosConfig)
          .then(({ data }) => {
            originalRequest.headers['Authorization'] = `JWT ${data.detail?.tokens?.access}`;
            originalRequest.data = originalRequest.data
              ? JSON.parse(originalRequest.data)
              : originalRequest.data;

            dispatch({ type: 'TOKEN_INFO', tokens: data.detail.tokens })

            processQueue(null, data.detail?.access);
            resolve(_axios(originalRequest));
          })
          .catch(err => {
            processQueue(err, null);
            reject(error);

            dispatch(actions.logout.removeData())
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(error);
  }
);